import './Card.css';

/* ─────────────────────────────────────────────────────────────
   CARD — Reusable styled card container.

   Props:
   - children:    content inside the card
   - className:   extra CSS classes for per-usage overrides
   - highlighted: bool — adds an accent-colored border + glow
   ───────────────────────────────────────────────────────────── */
function Card({ children, className = '', highlighted = false }) {
  const classes = [
    'card',
    highlighted ? 'card-highlighted' : '',
    className,
  ].filter(Boolean).join(' ');

  return <div className={classes}>{children}</div>;
}

export default Card;
